import React, { Component, createRef } from "react";
import { Link } from "react-router-dom";
import {
  Message,
  Icon,
  Button,
  Header,
  Segment,
  Dimmer,
  Loader,
  Rail,
  Sticky,
  Ref,
  Statistic,
  Grid,
  Transition,
  Responsive,
} from "semantic-ui-react";
import RenderedApp from "./RenderedApp";
import GraderApi from "../utils/GraderApi";
import DashboardApi from "../utils/DashboardApi";
import AppHeader from "./AppHeader";
import { HotKeys } from "react-hotkeys";
import "./Grader.css";
import Storage from "../utils/Storage";
import UserApi from "../utils/UserApi";
import AdminApi from "../utils/AdminApi";

const KEYMAP = {
  TECHNICAL_SCORE: ["0", "1", "2", "3", "4"],
  PASSION_SCORE: ["q", "w", "e", "r", "t", "y"],
  SUBMIT: "enter",
  NEXT: "right",
  BACK: "left",
};

class Grader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      current_app: null,
      next_app: null,
      technical_score: null,
      passion_score: 0,
      scoreKey: null,
      stats: null,
      submitting: false,
      fucked_up: false,
      display_banner: false,
      user_id: null,
      current_round: null,
      skipping: false,
      previous: false,
      skipped_applicants: [],
      scored_applicants: [],
      previous_index: 0,
      previousUID: null,
      tempPreviousUID: null,
    };
    this.breaks = [751, 550];
    this.submitting = false;
    this.contextRef = createRef();
    this.refresh = this.refresh.bind(this);
    this.loadNewApp = this.loadNewApp.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleTechnicalScoreChange = this.handleTechnicalScoreChange.bind(this);
    // this.handlePassionScoreChange = this.handlePassionScoreChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdateSubmit = this.handleUpdateSubmit.bind(this)
    this.handleFuckedUp = this.handleFuckedUp.bind(this);
    this.handleDismissBanner = this.handleDismissBanner.bind(this);
    this.toggleSkippedView = this.toggleSkippedView.bind(this);
    this.togglePreviousView = this.togglePreviousView.bind(this);
    // console.log("URL: " + props.match.params.app_id);
  }

  HANDLERS = {
    TECHNICAL_SCORE: (event) => {
      if (!this.state.submitting) {
        const technical = "01234";
        const index = technical.search(event.key)
        if ((index = technical.search(event.key)) !== -1) {
          this.setState({
            technical_score: (index+1).toString()
          })
        }
      }
    },
    // PASSION_SCORE: (event) => {
    //   if (!this.state.submitting) {
    //     const passion = "qwerty";
    //     const index = passion.search(event.key)
    //     if ((index = passion.search(event.key)) !== -1) {
    //       this.setState({
    //         passion_score: (index+1).toString()
    //       })
    //     }

    //   }
    // },
    SUBMIT: this.handleSubmit.bind(this),
    NEXT: this.handleNext.bind(this),
  };


  componentDidMount() {
    console.log("Comp mounted")
    if (this.state.loading) {
      this.refresh();
    }
  }

  refresh() {

    DashboardApi.stats().then((response) => {
      console.log("dashboard stats", response);
      this.setState({
        stats: response.data,
        apps_read: response.data.user_stats.round_apps_read,
        apps_left:
          response.data.global_stats.grader_target -
          response.data.user_stats.round_apps_read,
        current_round: response.data.global_stats.current_round.id,
        user_id: response.data.user.id
      });
    });


    console.log("id", this.props.match.params.app_id);
    GraderApi.getApplicant(null, this.props.match.params.app_id).then(
      (response) => {
        console.log("app", response.data.applicant);
        this.setState({
          current_app: response.data.applicant,
          display_banner: !response.data.success,
        });
        if (response.data.applicant !== null) {
          GraderApi.getApplicant(response.data.applicant.id).then(
            (response) => {
              console.log(response);
              this.setState({
                next_app: response.data.applicant,
                loading: false,
              });
            }
          );
        } else {
          this.setState({ loading: false });
        }
      }
    );
  }

  loadNewApp() {
    console.log("previousUID begin", this.state.previousUID)
    if (!(this.state.skipping) && !(this.state.previousUID)) {
      if (this.state.next_app !== null) {
        let next = this.state.next_app.id;
        this.setState({
          current_app: this.state.next_app,
          next_app: null,
          submitting: false,
        });
        GraderApi.getApplicant(next).then((response) => {
          console.log(response)
          console.log("loaded queue");
          this.setState({
            next_app: response.data.applicant,
            previousUID: this.state.tempPreviousUID,
          });
        });
      } else {
        GraderApi.getApplicant().then((response) => {
          this.setState({
            current_app: response.data.applicant,
            submitting: false,
            previousUID: this.state.tempPreviousUID,
          });
          GraderApi.getApplicant(response.data.applicant).then((response) => {
            this.setState({
              next_app: response.data.applicant,
              previousUID: this.state.tempPreviousUID,
            });
          });
        });
      }
    } else if (this.state.skipping) {
      if (this.state.skipped_applicants.length !== 0) {
        console.log('hai, skipped app loading');
        const update_skipped = this.state.skipped_applicants.slice(1)
        this.setState({
            current_app: this.state.skipped_applicants[0],
            next_app: this.state.skipped_applicants.length > 1 ? this.state.skipped_applicants[1] : null,
            skipped_applicants: update_skipped,
            submitting: false
        });
      } else {
        console.log('no more skipped apps to load :>');
        this.setState({
          current_app: null,
          submitting: false
      });
      }
    } 
    else if (this.state.previousUID) {
      console.log("previousUID", this.state.previousUID);
      GraderApi.getApplicant(null,this.state.previousUID).then((response) => {
        console.log("response", response);
        this.setState({
          current_app: response.data.applicant,
          previousUID: null,
          submitting: false
        });
      });
      console.log("applicant previous,, null is ", this.state.previousUID)
      // if (this.state.scored_applicants.length !== 0) {
      //   console.log('hai, old app loading');
      //   this.setState({
      //       current_app: this.state.scored_applicants[this.state.previous_index],
      //       technical_score: this.state.scored_applicants[this.state.previous_index].technical_value.toString(),
      //       passion_score: this.state.scored_applicants[this.state.previous_index].passion_value.toString(),
      //       next_app: null,
      //       submitting: false
      //   });
      //   console.log('old app', this.state.scored_applicants[this.state.previous_index]);
        
      // } else {
      //   console.log('no more old apps to load :>');
      //   this.setState({
      //     current_app: null,
      //     submitting: false
      // });
      // }
    }
  }

  handleTechnicalScoreChange(event, { name }) {
    this.setState({ technical_score: name });
  }

  // handlePassionScoreChange(event, { name }) {
  //   this.setState({ passion_score: name });
  // }

  handleSubmit() {
    if (this.state.current_app === null) {
      return;
    }
    if (this.state.technical_score !== null &&  !this.state.submitting) {
      console.log("submitting!");
      this.setState({
        submitting: true,
      });
      if (this.state.previous) {
        let data = {
          applicant_id: this.state.current_app.profile.uid,
          technical_value: this.state.technical_score,
          passion_value: this.state.passion_score,
        };
        GraderApi.updateScore(data).then((response) => {
          if (response.data.success) {
            this.handleUpdateSubmit();
            console.log("updating score succeeded");
            console.log(response.data, response.data.value);
          }
          else {
            console.log("Updating score failed");
          }
        });
      }
      else {
        if (this.state.score === "0") {
          let data = { applicant_id: this.state.current_app.profile.uid };
          GraderApi.blacklist(data).then((response) => {
            this.setState({
              technical_score: null,
              passion_score: 0,
              fucked_up: false,
              apps_read: this.state.apps_read + 1,
              apps_left: this.state.apps_left - 1,
              previous: true,
            });
            this.loadNewApp();
          });
        } else {
          if (this.state.fucked_up) {
            GraderApi.add_bad_mit_app(this.state.current_app.id);
          }
          console.log("applicant_id: ", this.state.current_app.profile.uid);
          let data = {
            applicant_id: this.state.current_app.profile.uid,
            technical_value: this.state.technical_score,
            passion_value: this.state.passion_score,
          };

          console.log("app_data: ", data)
          

          GraderApi.score(data)
            .then((response) => {
              if (response.data.success) {
                console.log("submitting success")
                this.setState({
                  previous: false,
                  technical_score: null,
                  passion_score: 0,
                  apps_read: this.state.apps_read + 1,
                  apps_left: this.state.apps_left - 1,
                  fucked_up: false,
                  previousUID: null,
                  tempPreviousUID: this.state.current_app.profile.uid,
                });
                this.loadNewApp();
              } else {
                console.log("Duplicate found, discarding grade");
                this.loadNewApp();
              }
            })
            .catch((error) => {
              alert("Submit failed: " + error);
              console.log(error);
              console.log("not-submitting!");
              this.setState({
                submitting: false,
                previous: false,
              });
            });
        }
      }
    }
  }

  handleUpdateSubmit() {
    console.log("handleUpdateSubmit");
    GraderApi.getScoredApplicants(this.state.user_id).then((response)=>{
      this.setState({
        scored_applicants: response.data.applicants,
        previous: true,
      }, () => {
        this.loadNewApp();
      })
    })
  }

  handleNext() {
    let data = {
      user_id: this.state.user_id,
      applicant_id: this.state.current_app.profile.uid,
      round_number: this.state.current_round 
    };

    GraderApi.skip(data)
      .then((response) => {
        this.setState({
          submitting: true,
        });
        this.loadNewApp();
      });
  }

  handleFuckedUp() {
    this.setState({
      fucked_up: !this.state.fucked_up,
    });
  }

  handleDismissBanner() {
    this.setState({
      display_banner: false,
    });
  }
  
  toggleSkippedView() {
    if (this.state.skipping) {
      this.setState({
        skipping: false,
        submitting: true,
      }, () => {
        this.loadNewApp();
      })
    } else {
      GraderApi.getSkippedApplicants(this.state.user_id).then(
        (response) => {
          console.log('skippedresponse', response);
          this.setState({
            skipped_applicants: [...response.data.applicants] ,  // could add current app to this if we wanted
            skipping: true,
            previous: false,
            technical_score: null,
            passion_score: 0,
          }, () => {
            console.log('calling it');
            this.loadNewApp();
          })
        }
      )
    }
    
  }

  togglePreviousView() {
    if (this.state.previousUID) {
      this.loadNewApp();

    }
    else{
      this.loadNewApp();
    }
    // if (this.state.previous) {
    //   console.log("previous is true");
    //   this.setState({
    //     previous: false,
    //     technical_score: null,
    //     passion_score: null,
    //   }, () => {
    //     this.loadNewApp();
    //   })
    // } else {
    //   console.log("previous is false");
    //   GraderApi.getScoredApplicants(this.state.user_id).then((response)=>{
    //     console.log('old apps');
    //     console.log(response.data.applicants)
    //     this.setState({
    //       scored_applicants: response.data.applicants,
    //       previous: true,
    //       previous_index: 0,
    //       skipping: false,
    //     }, () => {
    //       this.loadNewApp();
    //     })
    //   })
    // }
  }

  render() {
    return (
      <div>
        {this.state.loading && (
          <Dimmer active={this.state.loading} page>
            <Loader>Fetching Data</Loader>
          </Dimmer>
        )}
        {!this.state.loading && (
          <div>
            <HotKeys
              keyMap={KEYMAP}
              handlers={this.HANDLERS}
              focused={true}
              attach={window}
            >
              <Message
                hidden={!this.state.display_banner}
                negativeSkip
                floating
                onClick={this.handleDismissBanner}
              >
                <Message.Header>Application ID not found!</Message.Header>
                <Icon name="close" />
              </Message>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "1.2rem 1.5rem",
                }}
              >
                <span>
                  <Button as={Link} to="/dashboard" color="blue">
                    Dashboard
                  </Button>
                </span>
                <span>
                  {" "}
                  <Header as="h2" style={{ height: "1em", margin: "auto" }}>
                    App Reading
                  </Header>
                </span>
                <span>
                  <Button
                    color="orange"
                    as={Link}
                    to="/login"
                    floated="right"
                    onClick={Storage.logOut}
                  >
                    Log Out
                  </Button>
                </span>
              </div>

              <div>
                {/* <Button
                      color={this.state.skipping ? "green" : "gray"}
                      floated="center"
                      onClick={this.toggleSkippedView}
                    >
                      Skipped View
                  </Button> */}
                  <Button
                      color={this.state.previousUID ? "green" : "gray"}
                      floated="center"
                      onClick={this.togglePreviousView}
                    >
                      Previous View
                  </Button>
              </div>

              <Segment
                secondary
                attached="top"
                style={{ width: "100%", padding: "0", margin: "0", zIndex: 2 }}
              >
                <Sticky context={this.contextRef}>
                  <Segment.Group horizontal style={{ margin: "0", border: "0" }}>
                    <Segment style={{ width: "10%" }}>
                      {!this.state.previous && <Button
                        className="btn-grading"
                        active={this.state.technical_score === "0"}
                        name="0"
                        color="red"
                        onClick={() => {
                          this.setState({ technical_score: "0", passion_score: "0" });
                        }}
                      >
                        <Responsive
                          as={Icon}
                          style={{ margin: "0" }}
                          name="trash"
                          maxWidth={this.breaks[1] - 1}
                        ></Responsive>
                        <Responsive
                          as={Statistic.Label}
                          minWidth={this.breaks[1]}
                        >
                          Throw Away
                        </Responsive>
                        <Responsive
                          as={Statistic.Value}
                          minWidth={this.breaks[1]}
                        >
                          [0]
                        </Responsive>
                      </Button>}
                      {false &&
                        this.state.current_app &&
                        this.state.current_app.school ===
                          "Massachusetts Institute of Technology" && (
                          <Button
                            size="mini"
                            toggle
                            active={this.state.fucked_up}
                            onClick={this.handleFuckedUp}
                            style={{ marginTop: "1em" }}
                            color="orange"
                          >
                            This MIT boi fucked up
                          </Button>
                        )}
                    </Segment>
                    <Segment.Group vertical style={ { margin: "0", width: "70%" }}>
                      <Header style={{ paddingTop: "10px", margin: "0"}}>Score</Header >
                      <Segment style={{border:"0"}}>
                        <Statistic.Group
                          size="mini"
                          widths="six"
                          style={{ flexWrap: "nowrap" }}
                        >
                          <Statistic>
                            <Button
                              className="btn-grading"
                              active={this.state.technical_score === "0"}
                              name="0"
                              onClick={this.handleTechnicalScoreChange}
                            >
                              <Responsive as={Statistic.Label} minWidth={751}>
                                Poor
                              </Responsive>
                              <Statistic.Value>[0]</Statistic.Value>
                            </Button>
                          </Statistic>
                          <Statistic>
                            <Button
                              className="btn-grading"
                              active={this.state.technical_score === "1"}
                              name="1"
                              onClick={this.handleTechnicalScoreChange}
                            >
                              <Responsive as={Statistic.Label} minWidth={751}>
                                Subpar
                              </Responsive>
                              <Statistic.Value>[1]</Statistic.Value>
                            </Button>
                          </Statistic>
                          <Statistic>
                            <Button
                              className="btn-grading"
                              active={this.state.technical_score === "2"}
                              name="2"
                              onClick={this.handleTechnicalScoreChange}
                            >
                              <Responsive as={Statistic.Label} minWidth={751}>
                                Below Average
                              </Responsive>
                              <Statistic.Value>[2]</Statistic.Value>
                            </Button>
                          </Statistic>
                          <Statistic>
                            <Button
                              className="btn-grading"
                              active={this.state.technical_score === "3"}
                              name="3"
                              onClick={this.handleTechnicalScoreChange}
                            >
                              <Responsive as={Statistic.Label} minWidth={751}>
                                Above Average
                              </Responsive>
                              <Statistic.Value>[3]</Statistic.Value>
                            </Button>
                          </Statistic>
                          <Statistic>
                            <Button
                              className="btn-grading"
                              active={this.state.technical_score === "4"}
                              name="4"
                              onClick={this.handleTechnicalScoreChange}
                            >
                              <Responsive as={Statistic.Label} minWidth={751}>
                                Strong
                              </Responsive>
                              <Statistic.Value>[4]</Statistic.Value>
                            </Button>
                          </Statistic>
                        </Statistic.Group>
                      </Segment>
                    </Segment.Group>

                    <Segment
                      style={{ verticalAlign: "middle", width:"10%" }}
                    >
                      <Button
                        className="btn-grading"
                        color="green"
                        onClick={this.handleSubmit}
                      >
                        <Responsive
                          as={Icon}
                          style={{ margin: "0" }}
                          name="send"
                          maxWidth={this.breaks[1] - 1}
                        ></Responsive>
                        <Responsive
                          as={Statistic.Label}
                          minWidth={this.breaks[1]}
                        >
                          Submit
                        </Responsive>
                        <Responsive
                          as={Statistic.Value}
                          minWidth={this.breaks[1]}
                        >
                          [Enter]
                        </Responsive>
                      </Button>
                    </Segment>
                  </Segment.Group>
                </Sticky>
              </Segment>
              <Ref innerRef={this.contextRef}>
                <Grid attached="bottom">
                  <Grid.Column width={3} />

                  <Grid.Column width={10}>
                    {/* Reading current application */}
                    <Dimmer.Dimmable
                      dimmed={this.state.submitting}
                      style={{ zIndex: 1 }}
                    >
                      <Dimmer active={this.state.submitting} inverted />
                      <Segment
                        secondary
                        style={{ marginTop: "1em", zIndex: 0 }}
                      >
                        <AppHeader app={this.state.current_app} />
                        <Transition animation="scale" duration={500}>
                          <RenderedApp app={this.state.current_app} />
                        </Transition>
                        <Rail close position="left">
                          <Sticky
                            context={this.contextRef}
                            offset={window.outerHeight / 2}
                          >
                            <Segment basic>
                              {
                                this.state.previous && this.state.current_app && (this.state.previous_index !== this.state.scored_applicants.length-1) && <Header
                                style={{
                                  display: "flex",
                                  float: "right",
                                  margin: 0,
                                  cursor: "pointer",
                                }}
                                onClick={() => {this.setState({previous_index: this.state.previous_index + 1}, () => {this.loadNewApp()});}}
                                >
                                  Back {'<'}
                                </Header>
                              }
                            </Segment>
                          </Sticky>
                        </Rail>
                        <Rail close position="right">
                          <Sticky
                            context={this.contextRef}
                            offset={window.outerHeight / 2}
                          >
                            <Segment basic>
                              {this.state.previous ? (
                                this.state.current_app && (this.state.previous_index !== 0) && <Header
                                style={{
                                  display: "flex",
                                  float: "left",
                                  margin: 0,
                                  cursor: "pointer",
                                }}
                                onClick={() => {this.setState({previous_index: this.state.previous_index - 1}, () => {this.loadNewApp()});}}
                                >
                                  Next {'>'}
                                </Header>
                              )
                              : null /* (this.state.current_app && <Header
                                style={{
                                  display: "flex",
                                  float: "left",
                                  margin: 0,
                                  cursor: "pointer",
                                }}
                                onClick={this.handleNext}
                              >
                                Skip{" >"}
                              </Header>) */}
                            </Segment>
                          </Sticky>
                        </Rail>
                      </Segment>
                    </Dimmer.Dimmable>
                  </Grid.Column>

                  <Grid.Column width={3} />
                </Grid>
              </Ref>
            </HotKeys>
          </div>
        )}
      </div>
    );
  }
}

export default Grader;



// WEBPACK FOOTER //
// ./src/components/grader/Grader.js